import { render, staticRenderFns } from "./disabledTable.vue?vue&type=template&id=006e5201&scoped=true"
import script from "./disabledTable.vue?vue&type=script&lang=js"
export * from "./disabledTable.vue?vue&type=script&lang=js"
import style0 from "./disabledTable.vue?vue&type=style&index=0&id=006e5201&prod&lang=scss"
import style1 from "./disabledTable.vue?vue&type=style&index=1&id=006e5201&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "006e5201",
  null
  
)

export default component.exports